import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from "../@shared/shared.module";

import { PagesRoutingModule } from './pages-routing.module';
import { LayoutComponent } from '../layout/layout.component';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from '../layout/sidebar/sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ICasinoComponent } from './dashboard/i-casino/i-casino.component';
import { SportListComponent } from './sport-list/sport-list.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { RulesComponent } from './rules/rules.component';
import { InPlayComponent } from './in-play/in-play.component';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { MarketAnalysisComponent } from './market-analysis/market-analysis.component';
import { CasinoDetailComponent } from './casino-detail/casino-detail.component';
import { RaceListComponent } from './race-list/race-list.component';
import { DepositWithdrawComponent } from './deposit-withdraw/deposit-withdraw.component';
import { OtherPagesComponent } from './other-pages/other-pages.component';


@NgModule({
  declarations: [
    LayoutComponent,
    SidebarComponent,
    DashboardComponent,
    ICasinoComponent,
    SportListComponent,
    MyProfileComponent,
    RulesComponent,
    InPlayComponent,
    MobileMenuComponent,
    MarketAnalysisComponent,
    CasinoDetailComponent,
    RaceListComponent,
    DepositWithdrawComponent,
    OtherPagesComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
    SharedModule,
  ],
  providers: [],
})
export class PagesModule { }
